export const navLinks = [
  { label: '首頁', href: '/' },
  { label: '品牌介紹', href: '/about' },
  { label: '合作通路', href: '/stores' },
  { label: '常見問題', href: '/faq' },
];

export const heroContent = {
  label: '財經知識出版品牌',
  title: '看懂錢的流向，也看懂時代的方向。',
  subtitle: '財經錢線為崧博出版經銷品牌之一。本網站提供品牌介紹、正式出版書籍與崧博出版書籍資料庫查詢入口。',
  tagline: '財經不是只有數字，也是理解世界的方式。',
  ctaButtons: [
    { label: '了解財經錢線', href: '/about', variant: 'primary' },
    { label: '合作通路', href: '/stores', variant: 'outline' },
  ],
};

export const brandIntro = {
  title: '財經錢線文化，從財經知識理解生活與市場。',
  content: '財經錢線文化以財經內容為核心，關注金錢、投資、市場、商業、職場與經濟趨勢。我們希望把看似複雜的財經議題，整理成讀者可以理解、可以思考，也可以運用在生活與工作中的知識內容。在變動快速的時代，理解財經不是為了追逐短期答案，而是為了建立更穩定的判斷力。',
  cta: { label: '了解財經錢線文化', href: '/about' },
};

export const topics = [
  {
    id: 'financial-knowledge',
    title: '財經知識',
    description: '理解金錢、市場、資本、價格、風險與經濟運作，建立閱讀財經世界的基礎能力。',
    tags: ['財經知識', '市場理解', '經濟運作', '金錢流向', '財務判斷'],
    icon: 'ri-funds-line',
    href: '/topics/financial-knowledge',
    color: 'primary',
  },
  {
    id: 'investment',
    title: '投資理財',
    description: '整理投資觀念、資產配置、風險意識、長期理財與財務規劃相關內容。',
    tags: ['投資理財', '資產配置', '風險管理', '長期投資', '財務規劃'],
    icon: 'ri-line-chart-line',
    href: '/topics/investment',
    color: 'accent',
  },
  {
    id: 'money-mindset',
    title: '金錢思維',
    description: '從金錢觀、消費選擇、收入結構與個人財務習慣中，理解人如何和金錢相處。',
    tags: ['金錢觀', '消費選擇', '收入管理', '財務習慣', '個人理財'],
    icon: 'ri-psychotherapy-line',
    href: '/topics/money-mindset',
    color: 'secondary',
  },
  {
    id: 'business',
    title: '商業與企業',
    description: '從企業經營、商業模式、管理思維與市場競爭中，理解商業世界如何運作。',
    tags: ['商業書', '企業經營', '商業模式', '管理思維', '市場競爭'],
    icon: 'ri-building-2-line',
    href: '/topics/business',
    color: 'primary',
  },
  {
    id: 'economic-trends',
    title: '經濟趨勢',
    description: '關注總體經濟、產業變化、全球市場、政策影響與時代趨勢，協助讀者建立更大的觀察框架。',
    tags: ['經濟趨勢', '產業變化', '全球市場', '政策影響', '時代變化'],
    icon: 'ri-global-line',
    href: '/topics/economic-trends',
    color: 'accent',
  },
  {
    id: 'career-income',
    title: '職場收入',
    description: '從職場競爭力、副業、收入成長、工作選擇與職涯判斷中，理解個人如何在現代經濟中建立財務基礎。',
    tags: ['職場收入', '副業思維', '收入成長', '職涯判斷', '工作選擇'],
    icon: 'ri-briefcase-line',
    href: '/topics/career-income',
    color: 'secondary',
  },
];

export const latestBooks = [
  {
    id: '9786264085212',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6531e4bd-58db-4423-bcfd-cffdd6e809c4_compressed_9786264085212.webp',
    title: '看懂股市，不被行情牽著走：給普通人的圖解投資理財課',
    author: '洪子暮',
    publishDate: '2026.01',
    tags: ['投資理財', '圖解學習'],
    summary: '從企業價值、合理價格、市場情緒到風險控管，建構一套普通人也能掌握的投資判斷系統。',
  },
  {
    id: '9786264085229',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/5bae9cb0-8de2-44bc-bb21-e69572d9cba7_compressed_9786264085229.webp',
    title: '氣運，把好運變成一種能力',
    author: '觀止鏡',
    publishDate: '2026.01',
    tags: ['金錢思維', '正向循環'],
    summary: '用心理學、腦科學與行為科學重新解構運氣，從心念、身體、關係到行動，建立吸引機會的正向循環。',
  },
  {
    id: '9786264085144',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/2f915517-9a94-4213-af6a-a18a3922ec97_compressed_9786264085144_3D_72dpi.webp',
    title: '金錢時間差：可惡！帳單總比收入先一步抵達',
    author: '李彥廷',
    publishDate: '2026.01',
    tags: ['財經知識', '時間管理'],
    summary: '從薪水、帳單、分期到現金流，揭開收入提高卻越來越沒安全感的真相，讓錢在正確時間解決問題。',
  },
  {
    id: '9786267865699',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/fc863c04-18a8-4136-b269-d36886274ecc_compressed_9786267865699_3D_72dpi.webp',
    title: '天后聖帝武則天',
    author: '山陽、郭豔紅',
    publishDate: '2026.01',
    tags: ['歷史智慧', '權力經營'],
    summary: '走出深宮，臨朝稱帝，一代女皇以鐵血手腕扭轉乾坤。看武則天如何在腥風血雨中稱霸天下，逆轉人生。',
  },
  {
    id: '9786264085083',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/54ad62bb-2525-4d7a-9cdd-1dd1fa85722a_compressed_9786264085083.webp',
    title: '非救火式管理！法約爾的管理職能課',
    author: '[法]亨利．法約爾 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['商業書', '管理思維'],
    summary: '從職能分工到主管訓練，看懂企業穩定成長的基本功，讓管理不只是少數人的本事。',
  },
  {
    id: '9786264085090',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/c7b5affe-4a9c-4a6e-a409-dceb7d2c2ec7_compressed_9786264085090.webp',
    title: '管理不能只看數字：梅堯帶你讀懂效率背後的人性',
    author: '[美]艾爾頓．梅堯 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['商業書', '管理思維'],
    summary: 'KPI壓力、重複工作與非正式群體，重新理解士氣、信任與長期合作，效率提高不代表人能長久承受。',
  },
  {
    id: '9786264085076',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/21fa4b03-b83e-4cdc-b6dd-96926839d6f8_compressed_9786264085076.webp',
    title: '金融泡沫的底層邏輯：約翰．勞與密西西比狂熱',
    author: '[英]約翰．勞 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '金融史'],
    summary: '從發行準備金到銀行券流通，看信用如何從交易工具變成投機燃料，錢不只是財富，而是一套交易秩序。',
  },
  {
    id: '9786264085069',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/e5404056-812a-4bed-8456-e237664ac557_compressed_9786264085069.webp',
    title: '艾默生的效率管理十二原則',
    author: '[美]哈林頓．艾默生 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['商業書', '管理思維'],
    summary: '編譯自艾默生《效率十二原則》，以現代職場語言重讀百年前的管理經典，效率管理的第一步是看懂努力在哪裡被浪費。',
  },
  {
    id: '9786264085045',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6e9234ec-c99b-4d24-bcc4-fec812838fd5_compressed_9786264085045.webp',
    title: '草莽的逆襲',
    author: '雲千重',
    publishDate: '2026.01',
    tags: ['職場收入', '個人成長'],
    summary: '不是命好才出頭！在夾縫裡找機會，在人情中借力量。用微習慣累積信心，用高情商化解矛盾，一步步找回生活主動權。',
  },
  {
    id: '9786264085038',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6f83293b-b87e-44dd-8aa9-04c37bccb650_compressed_9786264085038.webp',
    title: '努力被房價收走：亨利．喬治論進步與貧困',
    author: '[美]亨利．喬治 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '社會議題'],
    summary: '土地壟斷、租金上升與世代門檻，破解越勤奮越難安身的城市困局。真正重要的不是城市有沒有進步，而是成果有沒有回到多數人的生活裡。',
  },
  {
    id: '9786264084994',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/20505382-af3b-4fc8-88fa-0bfdded19c75_compressed_9786264084994.webp',
    title: 'GDP成長肥到誰？李嘉圖帶你讀懂房價、薪資、稅負與全球貿易的成本轉嫁',
    author: '[英]大衛．李嘉圖 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '社會議題'],
    summary: '從生活成本到薪資報酬，從企業獲利到全球貿易，揭開經濟成長背後的利益流向。GDP上升之後，收益究竟流向誰？',
  },
  {
    id: '9786264085021',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6d76f375-8581-4faf-9909-2055311f0e80_compressed_9786264085021.webp',
    title: '致富不是暴富的幻想！華勒斯．華特斯談財富科學',
    author: '[美]華勒斯．華特斯 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['金錢思維', '個人成長'],
    summary: '金錢信念 × 行動秩序 × 價值創造，從羞愧、匱乏與焦慮中找回人生選擇權。財富不是靠運氣，而是靠意識與行為的系統性轉變。',
  },
  {
    id: '9786264084987',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/17dc7a89-33f4-49de-bf19-1b11516207e0_compressed_9786264084987.webp',
    title: '讓努力變值錢：巴納姆的二十條致富法則',
    author: '[美]P.T.巴納姆 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['職場收入', '財富法則'],
    summary: '從選職涯到賺第一桶金，真正重要的不是哪裡最熱門，而是你是否站在能長期累積的位置上。巴納姆的二十條原則，讓努力持續產生價值。',
  },
  {
    id: '9786264084970',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/5f720f12-eb4f-4298-82e6-6fb1a8aa4955_compressed_9786264084970.webp',
    title: '清代的華爾街，喬家大院',
    author: '陳捷、張昕 著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '商業書'],
    summary: '走西口，闖四方，喬家百年寫榮光。看懂票號、商號、宅院與家族治理交織出的百年傳奇。一座大院藏興替，半部晉商大卷章。',
  },
  {
    id: '9786264084949',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/f9e4fe28-6d81-44a3-b7fe-bcbb23639fdc_compressed_9786264084949.webp',
    title: '金融恐慌的白芝浩原則',
    author: '[英]沃爾特．白芝浩 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '金融史'],
    summary: '金融危機不只是銀行家的事！存款、轉帳、房貸、薪水與企業週轉都建立在對銀行的信任之上。從看懂銀行體系的運作邏輯開始，理解現代金融世界。',
  },
  {
    id: '9786264084932',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/75cf0792-1314-4a51-a109-721c6f96d958_compressed_9786264084932.webp',
    title: '投機狂潮：查爾斯．麥凱談群眾的幻想與瘋狂',
    author: '[英]查爾斯．麥凱 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '金融史'],
    summary: '從鬱金香到股票，人類從未停止為下一個幻想買單。價格會上漲，故事會發酵，群眾也會一起失去清醒。當所有人都害怕錯過，泡沫往往已經開始成形。',
  },
  {
    id: '9786264084895',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6bf590d6-5731-4fda-a160-6dac510d32a6_compressed_9786264084895.webp',
    title: '當消費變成證明，韋伯倫論炫耀經濟學',
    author: '[美]托斯丹．韋伯倫 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '社會議題'],
    summary: '從精品、名校、豪宅到社群曬生活，消費社會的身分競賽。有錢人最怕的不是沒錢，是你沒看見！看懂炫耀性消費，就能看清現代人的焦慮。',
  },
  {
    id: '9786264084840',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/759cd480-81d2-48e7-be6f-eae9c55feeda_compressed_9786264084840_3D_72dpi.webp',
    title: 'A型人 × 星座密碼，12種特質全解析',
    author: '張祥斌 編著',
    publishDate: '2026.01',
    tags: ['個人成長', '性格分析'],
    summary: '完美主義傾向、壓抑情感、渴望被理解、重視安全感。全面剖析A型人在愛情與人際互動中的模樣，解讀理性外表下A型人真實的內心。',
  },
  {
    id: '9786264084819',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/7a0bf1ac-11cb-43c0-ab2b-3b4682ca0528_compressed_9786264084819_3D_72dpi.webp',
    title: '行為背後的邏輯：88個關鍵心理學效應',
    author: '蘇海峰 著',
    publishDate: '2026.01',
    tags: ['個人成長', '心理學'],
    summary: '討好型人格、自我效能感、損失規避、倖存者偏差、課題分離。從情緒管理到人際互動，全面拆解日常行為背後的心理機制，看懂你以為的「自主」選擇。',
  },
  {
    id: '9786264084796',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/932cbc48-a033-4fdd-85ea-10a807683c55_compressed_9786264084796.webp',
    title: '越努力越空虛：停止原地消耗！那些很努力、很清醒，卻沒有前進感的真正原因',
    author: '林向衡 著',
    publishDate: '2026.01',
    tags: ['個人成長', '職場心理'],
    summary: '明明一整天都很忙，卻說不出到底做了什麼；事情做完了，卻總覺得哪裡不對勁。停止原地消耗，找到那些很努力、很清醒，卻沒有前進感的真正原因。',
  },
  {
    id: '9786264084802',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/433a8f96-b7af-4f03-a8ed-9ad2193f6277_compressed_9786264084802.webp',
    title: '你的職場含金量，來自每天的升級',
    author: '周予衡 著',
    publishDate: '2026.01',
    tags: ['職場收入', '個人成長'],
    summary: '從自我效能到成果表達，打造主管授權的關鍵實力，讓自己值得被投資。把時間花在高槓桿成果上，把能力鍛造成稀缺資源，讓你更不容易被取代。',
  },
  {
    id: '9786264084772',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/69814560-a555-4a17-b2a4-10f2888c018c_compressed_9786264084772_3D_72dpi.webp',
    title: '失衡，一場戰爭由誰主導？',
    author: '李硯修 著',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '地緣政治'],
    summary: '從誤判、盟友到收場，看懂現代戰爭真正怎麼決定勝負。不必更強也能掌控局面，不必摧毀也能讓對手崩解，真正的戰略是對「選擇」的控制。',
  },
  {
    id: '9786264084789',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/edb23738-d64e-4821-8aa8-a16eb30b564e_compressed_9786264084789_3D_72dpi.webp',
    title: '從氏族到階級，中國政治社會史',
    author: '梁園東 著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '政治'],
    summary: '從氏族制度到封建體系，以政治結構與生產關係解析中國歷史發展的內在邏輯。圖騰氏族、封建體系、商品經濟，重構原始社會至封建時代的演變過程。',
  },
  {
    id: '9786264084758',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/ad94f681-bda5-4100-b5a6-5fe75f60f550_compressed_9786264084758_3D_72dpi.webp',
    title: '未竟的轉型，中國社會發展論',
    author: '梁園東 著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '社會議題'],
    summary: '從封建解體到小資產階級社會，中國為何未出現制度性的歷史突破？農商制衡×封建解體×小資產階級，從農業基礎與商業限制的結構性分析。',
  },
  {
    id: '9786264084765',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/f907386b-3c9b-4277-ad8b-083711cb9278_compressed_9786264084765_3D_72dpi.webp',
    title: '票號，晉商金融帝國',
    author: '衛聚賢 著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '商業書'],
    summary: '走入票號世界，看見晉商匯兌與商業往來的日常。票號起源、分號分布、組織制度、帳簿運作，重現《喬家大院》背後晉商興衰史的真實樣貌。',
  },
  {
    id: '9786264084734',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/0969c1c1-89c1-4cc7-866b-5c42d9f28ae5_compressed_9786264084734_3D_72dpi.webp',
    title: '優雅進擊！自信女子的升值機密',
    author: '俞姿婷 著',
    publishDate: '2026.01',
    tags: ['職場收入', '個人成長'],
    summary: '吸引力、婚姻經營、理財實力、職場心機。抓住他的心，先穩住自己的節奏與底氣。甜蜜不靠運氣，幸福來自清醒與布局。',
  },
  {
    id: '9786264084697',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/41363e5f-d8ee-4a5a-9ac4-e22b8cae8c5a_compressed_9786264084697_3D_72dpi.webp',
    title: '擺脫「精緻窮」的生活整理術',
    author: '章含 著',
    publishDate: '2026.01',
    tags: ['金錢思維', '個人成長'],
    summary: '美麗不必靠名牌。儀態修練×穿搭品味×心態升級，強化魅力氣場，養成自信風采！氣質來自日常選擇，一點一滴累積成屬於自己的光芒。',
  },
  {
    id: '9786264084673',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/19b806f5-8533-4d4d-ab95-40659527d54a_compressed_9786264084673_3D_72dpi.webp',
    title: '精準生長，20歲後如何高效率進化？',
    author: '崔英勝 著',
    publishDate: '2026.01',
    tags: ['職場收入', '個人成長'],
    summary: '創造需求×廣結善緣×大膽行動，13堂人生通識課，從此告別焦慮與混亂。沒有方向，再努力都是原地打轉。十三種能力，重新校準人生指南針。',
  },
  {
    id: '9786264084666',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/655d22a8-a466-4d94-bb94-3c8d9de341e0_compressed_9786264084666_3D_72dpi.webp',
    title: '經濟學之父亞當斯密的道德情感論',
    author: '[英]亞當·斯密 原著、林真如、劉燁 編著',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '哲學思想'],
    summary: '從個體自私到群體共好，利他行為如何達成利己結果？用日常經驗建構完整思考框架，從情感出發思考正義、責任與美德。',
  },
  {
    id: '9786264084598',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/67d0573c-3908-4768-8e05-087cd5017f14_compressed_9786264084598_3D_72dpi.webp',
    title: '成功者的思考迴路',
    author: '[美]拿破崙·希爾 著、宋奕婕 編譯',
    publishDate: '2026.01',
    tags: ['職場收入', '個人成長'],
    summary: '解構拿破崙·希爾的致勝心智模式，真正拉開人生差距的往往藏在每天的思考與選擇裡。',
  },
  {
    id: '9786264084550',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/fba9e635-cabb-4ec9-8b64-b5aeb357b33d_compressed_9786264084550_3D_72dpi.webp',
    title: '才富管理學，主管最常忽略的七種用人策略',
    author: '喬友乾 著',
    publishDate: '2026.01',
    tags: ['商業書', '管理思維'],
    summary: '從領導決策到組織設計，建立能留人、育人並持續成長的團隊運作系統。管理的成效來自人才配置與信任機制的長期累積。',
  },
  {
    id: '9786264084505',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/d66d1589-b02e-4e3a-90ed-bce30c65b606_compressed_9786264084505_3D_72dpi.webp',
    title: '失控購物欲，無孔不入的「演算法」消費陷阱',
    author: '劉燁 著',
    publishDate: '2026.01',
    tags: ['金錢思維', '消費心理'],
    summary: '情緒操控、假性需求、從眾心理，你的所有消費行為都只是在為「情緒」買單。客製化推送、多巴胺陷阱、物欲綁架，演算法正在騙你花錢。',
  },
  {
    id: '9786264084499',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/bd2a94c3-06ef-465b-8390-1052d7c4d3d9_compressed_9786264084499_3D_72dpi.webp',
    title: '丞相，起風了！諸葛亮教你風向亂時精準布局',
    author: '東方聞睿 編著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '職場策略'],
    summary: '三十六計現代解讀，風起亂局中逆勢勝出，36個看清職場底層邏輯的生存錦囊。情境×原則×行動，將歷史智謀活用在當下人生。',
  },
  {
    id: '9786264084413',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/3b3d639e-935c-4462-816f-c7602f2b9388_compressed_9786264084413_3D_72dpi.webp',
    title: '過渡型統治者，注定崩解的軍閥集團',
    author: '張鳴 著',
    publishDate: '2026.01',
    tags: ['歷史智慧', '政治'],
    summary: '從傳統王朝崩潰到近代中國，軍閥如何在失序年代填補統治真空，又為何無法成為真正的國家？組織關係、利益分配、意識形態，看懂權力過渡的本質。',
  },
  {
    id: '9786264084390',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/428f866e-b256-4f86-858f-916d3f9159d9_compressed_9786264084390_3D_72dpi.webp',
    title: '退休之後，為什麼身體開始嚇你',
    author: '謝蘭舟 著',
    publishDate: '2026.01',
    tags: ['個人成長', '健康心理'],
    summary: '離開工作角色後，那些恐病、焦慮與停不下來的確認行為。退休之後不是清閒，而是心理重新定位的開始。當身體變慢、情緒變多，真正需要的是一套走得久的調整方式。',
  },
  {
    id: '9786264084383',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/e149431d-f6e5-4532-96a5-5e344e13ab1d_compressed_9786264084383_3D_72dpi.webp',
    title: '防禦型讀心：不被直覺誤導、不被謊言操控，FBI等級的行為科學觀察筆記',
    author: '李祐元 著',
    publishDate: '2026.01',
    tags: ['個人成長', '心理學'],
    summary: '你以為自己觀察入微，其實多半已經下了結論。真正需要被訓練的，是在判斷成形之前多停留一秒。不被直覺誤導、不被謊言操控，建立防禦型讀心能力。',
  },
  {
    id: '9786264084284',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/b66a51bf-1082-46f6-aa41-0387288a68bc_compressed_9786264084284_3D_72dpi.webp',
    title: '奈特論風險、不確定性與利潤',
    author: '[美]法蘭克·奈特 著、伊莉莎 編譯',
    publishDate: '2026.01',
    tags: ['經濟趨勢', '商業書'],
    summary: '在不可預測世界中，判斷如何成為利潤來源。風險能預測嗎？利潤來自承擔不確定的勇氣。重新整理原著架構，初學者也能看懂市場決策的核心邏輯。',
  },
  {
    id: '9786264084246',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/6b5d00ea-64d4-42fc-ac3e-d207b7539420_compressed_9786264084246_3D_72dpi.webp',
    title: '搞懂主管的心理筆記',
    author: '徐博年 著',
    publishDate: '2026.01',
    tags: ['職場收入', '管理思維'],
    summary: '從職場互動、信任、溝通、決策到帶人心，讓你更懂領導也被領導。當權威失效、命令無力，影響力才是讓人願意跟隨的關鍵。',
  },
  {
    id: '9786264084239',
    cover: 'https://storage.helloreaddy.io/project_files/32ab0c7e-b33a-4beb-bc8e-ca717adf854f/fa6a32b2-a0b7-477a-9d0f-92c3bddfb4ca_compressed_9786264084239_3D_72dpi.webp',
    title: '人際關係中的情緒科學',
    author: '吳載昶 著',
    publishDate: '2026.01',
    tags: ['個人成長', '心理學'],
    summary: '學會辨識情緒與偏誤，讓人際互動從反射走向有意識調節。理解他人不在行為表面，而在左右判斷的心理機制。降低誤讀、改善對話、提升連結品質。',
  },
];

export const readingGuides = [
  {
    id: 'guide-1',
    title: '財經知識入門閱讀指南',
    description: '從價格、資本、風險到市場運作，建立財經世界的基礎概念地圖。',
    icon: 'ri-book-open-line',
    href: '/topics/financial-knowledge',
  },
  {
    id: 'guide-2',
    title: '投資理財觀念書單',
    description: '整理資產配置、風險管理與長期財務規劃的核心觀念書目。',
    icon: 'ri-line-chart-line',
    href: '/topics/investment',
  },
  {
    id: 'guide-3',
    title: '金錢思維閱讀指南',
    description: '從金錢觀、消費習慣到收入結構，理解人與金錢的關係。',
    icon: 'ri-lightbulb-line',
    href: '/topics/money-mindset',
  },
  {
    id: 'guide-4',
    title: '商業模式與企業經營書單',
    description: '從企業案例、商業模式到管理思維，理解商業世界的運作邏輯。',
    icon: 'ri-building-line',
    href: '/topics/business',
  },
  {
    id: 'guide-5',
    title: '經濟趨勢閱讀指南',
    description: '關注總體經濟、全球市場與產業變化，建立更大的觀察框架。',
    icon: 'ri-global-line',
    href: '/topics/economic-trends',
  },
  {
    id: 'guide-6',
    title: '職場收入與個人財務書單',
    description: '從收入成長、職涯選擇到財務基礎，建立個人財務的穩定架構。',
    icon: 'ri-briefcase-line',
    href: '/topics/career-income',
  },
];

export const columnCategories = [
  { id: 'finance-notes', label: '財經筆記', href: '/columns' },
  { id: 'investment', label: '投資理財', href: '/columns' },
  { id: 'money-mindset', label: '金錢思維', href: '/columns' },
  { id: 'business-observation', label: '商業觀察', href: '/columns' },
  { id: 'economic-trends', label: '經濟趨勢', href: '/columns' },
  { id: 'career-income', label: '職場收入', href: '/columns' },
];

export const recentArticles = [
  {
    id: 'article-1',
    title: '為什麼理解金錢流向，比記帳更重要？',
    excerpt: '記帳可以記錄支出，但理解金錢流向可以幫助你做出更好的財務選擇。這不是技巧問題，而是觀念問題。',
    category: '財經筆記',
    date: '2025.12.10',
    href: '/columns',
  },
  {
    id: 'article-2',
    title: '從一本商業書中，看懂市場競爭的三個層次',
    excerpt: '市場競爭不只是比價格和產品。從商業模式到企業策略，競爭發生在三個不同的層次。',
    category: '商業觀察',
    date: '2025.11.28',
    href: '/columns',
  },
  {
    id: 'article-3',
    title: '長期投資不是時間長，而是判斷穩',
    excerpt: '長期投資的重點不是持有時間，而是你有沒有建立穩定的判斷方式。',
    category: '投資理財',
    date: '2025.11.15',
    href: '/columns',
  },
];

export const cooperationContent = {
  title: '在哪裡找到財經錢線文化的書？',
  description: '讀者可透過崧博出版合作通路平台，搜尋財經錢線文化相關作品。不同平台上架狀態可能有所不同，實際書籍資訊請以各平台頁面為準。',
  ctas: [
    { label: '查看合作通路', href: '/stores', variant: 'primary' },
    { label: '前往博客來品牌書目', href: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=sonbookservice', variant: 'outline', external: true },
  ],
};

export const homeFaqs = [
  {
    question: '財經錢線文化出版哪些類型的書？',
    answer: '財經錢線文化主要出版財經知識、商業理財、投資觀念、金錢思維、經濟趨勢、企業經營與職場收入相關作品。',
  },
  {
    question: '財經錢線文化適合哪些讀者？',
    answer: '財經錢線文化適合想理解財經知識、建立理財觀念、關注市場變化、商業思維、經濟趨勢與個人財務選擇的讀者。',
  },
  {
    question: '財經錢線文化和崧博出版是什麼關係？',
    answer: '財經錢線為崧博出版經銷品牌之一，由崧博出版事業有限公司負責經銷與通路發行，主要聚焦財經、商業與理財類出版內容。',
  },
  {
    question: '財經錢線文化和山頂視角文化有什麼不同？',
    answer: '財經錢線文化主要聚焦財經內容、投資理財、金錢思維、商業與經濟趨勢；山頂視角文化則更偏宏觀社會觀察、政治歷史、制度結構與以古諷今。',
  },
  {
    question: '財經錢線文化的內容是投資建議嗎？',
    answer: '不是。財經錢線網站內容以書籍導讀、財經閱讀與知識整理為目的，不構成投資、理財、稅務、法律或其他專業建議。',
  },
  {
    question: '財經錢線文化的書在哪裡可以購買？',
    answer: '讀者可透過博客來品牌書目與崧博出版合作通路平台搜尋財經錢線出版作品。',
  },
];

export const bottomCta = {
  title: '從閱讀開始，建立更清楚的財經判斷。',
  description: '無論你想理解金錢、投資、市場、企業經營，或正在思考自己的收入與未來選擇，財經錢線文化都希望從閱讀開始，陪你建立更穩定的財經理解。',
  buttons: [
    { label: '瀏覽購書通路', href: '/stores', variant: 'primary' },
    { label: '回到崧博出版', href: 'https://sonbook.net', variant: 'outline', external: true },
  ],
};

export const footerContent = {
  description: '財經錢線為崧博出版經銷品牌之一。本網站提供品牌介紹、正式出版書籍與崧博出版書籍資料庫查詢入口。網站內容不構成投資、理財、稅務、法律或其他專業建議。',
  links: [
    { label: '關於財經錢線', href: '/about' },
    { label: '合作通路', href: '/stores' },
    { label: '常見問題', href: '/faq' },
  ],
  externalLink: { label: '回到崧博出版', href: 'https://sonbook.net' },
};